<template>
    <content-link-edit v-if="content" :content="content" :back-route="{ name: 'system-content-links' }" />
</template>
<script>
import contentService from '../../../services/content.service'

import ContentLinkEdit from '../../common/content/link/content-link-edit.vue'

export default {
    name: 'system-content-links-edit',
    components: { ContentLinkEdit },
    data() {
        return {
            content: null
        }
    },
    computed: {
        contentId() {
            return this.$route.params.contentId;
        }
    },
    async created() {
        this.content = await contentService.getLink(this.contentId);
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/content/links/edit.vue